module.exports = __webpack_public_path__ + "static/img/page37.e468583.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page37.jpg
// module id = Zel4
// module chunks = 0